
const isTimestampGreaterThanCurrent = (timestamp: string) => {
    const currentTime = new Date().getTime() / 1000; // Get current time in seconds
    const currentTimeWithOffset = currentTime + (new Date().getTimezoneOffset() * 60); // Adjust for time zone offset
    return parseInt(timestamp, 10) > currentTimeWithOffset;
};

export { isTimestampGreaterThanCurrent };
